<ew-mat-dialog-custom>
  <ew-mat-stepper-custom
    [validations]="validations"
    [sendIn]="'last'"
    [textForSendButton]="'shared:next'"
    (send)="createInvoiceFund()">
    <ew-mat-stepper-custom-step
      ><div class="text-center grid gap-4 max-w-xl m-auto">
        <div class="mb-5 text-5xl font-bold">
          {{ 'invoiceFunds:currencyAccountTitle' | translate }}
        </div>
        <div class="">
          {{ 'invoiceFunds:currencyAccountSubtitle' | translate }}
        </div>
        <mat-progress-spinner
          class="m-auto my-5"
          [diameter]="24"
          [mode]="'indeterminate'"
          *ngIf="loadingCurrencies"></mat-progress-spinner>
        <div class="text-left grid xs:grid-cols-1 grid-cols-2 gap-4">
          <ew-currency-money
            [item]="item"
            [selected]="currency.value === item"
            [dollarConversion]="false"
            (click)="
              currency.setValue(item);
              rate.srcCurrency = item.currencyIso;
              getUpdatedValues()
            "
            *ngFor="let item of currencies"></ew-currency-money>
        </div>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <div class="text-center grid gap-4 max-w-2xl m-auto">
        <div class="mb-5 text-5xl font-bold">
          {{ 'invoiceFunds:selectCurrencyAccountTitle' | translate }}
        </div>
        <div class="">
          {{ 'invoiceFunds:selectCurrencyAccountSubtitle' | translate }}
        </div>
      </div>

      <!-- Currency -->
      <div class="pt-2 pb-4 px-8">
        <h2 class="text-sm">
          {{ 'invoiceFunds:confirmationCurrencyAccountTitle' | translate }}
        </h2>
        <div class="border border-gray-300 rounded-md p-2">
          <ew-table-card-item
            [img]="
              'https://flagcdn.com/' +
              (currency.value.currencyIso | currencyCountry) +
              '.svg'
            "
            [title]="
              ('currencyName:' + currency.value.currencyIso | translate) +
              ' (' +
              currency.value.currencyIso +
              ')'
            "
            [subtitle]="
              'Currency Balance: ' + payoutUpdatedValues.balanceBefore
            "></ew-table-card-item>
        </div>
      </div>

      <!-- Amount -->
      <div class="pb-4 px-8">
        <label for="amount-sent"
          ><h2 class="text-sm">
            {{ 'invoiceFunds:confirmationAmountSentTitle' | translate }}
          </h2></label
        >
        <span class="font-bold text-5xl mr-2">{{
          getCurrencySymbol(currency.value.currencyIso)
        }}</span>
        <input
          ewPreventScroll
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          class="font-bold text-5xl mb-4"
          [formControl]="amount"
          placeholder=".01"
          step="1"
          id="amount-sent" />

        <div>
          <mat-error *ngIf="amount.errors?.minAmount">
            <span class="text-sm text-red-500"
              >{{ 'invoiceFunds:amountGreaterThan' | translate }}
              {{ amount.errors?.minAmount }}</span
            >
          </mat-error>

          <mat-error *ngIf="amount.errors?.maxAmount">
            <span class="text-sm text-red-500"
              >{{ 'invoiceFunds:amountLowerThan' | translate }}
              {{ amount.errors?.maxAmount }}</span
            >
          </mat-error>
        </div>
        <p class="text-gray-500 text-sm">
          <span class="relative">
            {{ 'invoiceFunds:confirmationAmountSentBalance' | translate }}:
            {{ payoutUpdatedValues.balanceAfter }}
            <mat-progress-spinner
              class="absolute top-[50%] translate-y-[-50%] right-[-25px]"
              [diameter]="20"
              [mode]="'indeterminate'"
              *ngIf="loadingRate"></mat-progress-spinner>
          </span>
        </p>
      </div>

      <!-- Invoice Number -->
      <div class="px-8 pb-4">
        <mat-label class="font-semibold mb-2">
          <h2 class="text-sm">
            {{ 'invoiceFunds:confirmationInvoiceNumber' | translate }}
          </h2>
        </mat-label>
        <input
          class="block w-full p-2 border rounded-md {{
            invoiceNumber.errors && invoiceNumber.value !== ''
              ? 'border-red-500'
              : 'border-gray-300'
          }}"
          matInput
          step="2"
          [formControl]="invoiceNumber"
          id="invoice-number" />
        <mat-error *ngIf="invoiceNumber.errors && invoiceNumber.value !== ''">
          <span class="text-sm text-red-500">
            {{
              invoiceNumber.errors['pattern']
                ? ('shared:invoiceNumberPattern' | translate)
                : ('shared:isRequired' | translate)
            }}
          </span>
        </mat-error>
        <p class="text-gray-500 text-xs pt-1">
          {{ 'invoiceFunds:confirmationInvoiceNumberDescription' | translate }}
        </p>
      </div>

      <!-- Provider Name -->
      <div class="px-8 pb-4">
        <mat-label class="font-semibold mb-2">
          <h2 class="text-sm">
            {{ 'invoiceFunds:confirmationProviderName' | translate }}
          </h2>
        </mat-label>
        <input
          class="block w-full p-2 border rounded-md {{
            providerName.errors && providerName.value !== ''
              ? 'border-red-500'
              : 'border-gray-300'
          }}"
          matInput
          step="3"
          [formControl]="providerName"
          id="provider-name" />
        <mat-error *ngIf="providerName.errors && providerName.value !== ''">
          <span class="text-sm text-red-500">{{
            'shared:isRequired' | translate
          }}</span>
        </mat-error>
        <p class="text-gray-500 text-xs pt-1">
          {{ 'invoiceFunds:confirmationProviderNameDescription' | translate }}
        </p>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
